import axios from 'axios';
import '../_configs';

const config = global.gConfig;

// let mainUrl = config.webUrl;
// Temp Url for Mock
let mainUrl = 'https://6cbe0786-8a15-4078-aabd-01fef483050a.mock.pstmn.io';

// let apiKey = 'kPsnBymCZGuqf8XH{EmPCWRUcu7rcGPbqppx'; // Mock not support api key

const instance = axios.create({
  baseURL: mainUrl,
  headers: { Accept: 'application/json' }
  // headers: { Accept: 'application/json', 'x-mock-match-request-body': true }
});

// For Add Instance Options In the Future
// axios.defaults.headers.common['Authorization'] = 'AUTH TOKEN';
instance.defaults.headers.post['Content-Type'] = 'application/json';

// axios.defaults.headers.common['api key'] = 'x-api-key';
// instance.defaults.headers.post['x-api-key'] = apiKey;

// Interceptors Request
instance.interceptors.request.use(
  (request) => {
    // Edit request config
    const user = localStorage.getItem('user');
    if (user) {
      request.headers['Authorization'] = 'Bearer ' + user.token;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptors Response
instance.interceptors.response.use(
  (response) => {
    // Edit response config
    return response.data;
  },
  (error) => {
    return Promise.reject(error.response.data);
  }
);

export default instance;
